import React from 'react';
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/core';

const ChevronRightExpand = styled(({ isExpanded, ...other }) => (
  <ChevronRightRoundedIcon {...other} />
))<any, { isExpanded: boolean }>({
  transition: '200ms',
  transform: ({ isExpanded }) =>
    isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
});

ChevronRightExpand.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
};

export default ChevronRightExpand;
